import "./style.scss";

import Alert from "shared/ui/Alert";
import { FC } from "react";
import FileUploader from "../FileUploader";

type DocumentUploadProps = {
    type: string;
    setSelectedFiles: any;
    selectedFiles: any;
};

const DocumentUpload: FC<DocumentUploadProps> = ({ type, setSelectedFiles, selectedFiles }) => {
    const handleChangeFiles = (files: any) => {
        setSelectedFiles((prevSelectedFiles: any) => [...prevSelectedFiles, ...files]);
    };

    const handleFileRemoval = (file: File) => {
        const updatedFiles = selectedFiles.filter((selectedFile: any) => selectedFile !== file);
        setSelectedFiles(updatedFiles);
        console.log(`Type du document uploadé est : ${typeof file}`);
        
    };
    return (
        <div className="DocumentUpload">
            {type?.toLowerCase() === "passeport" || type.toLowerCase() === "passport" ? (
                <FileUploader
                    onChange={handleChangeFiles}
                    onDelete={handleFileRemoval}
                    title="Recto"
                    fileLimit={1}
                    maxFileSize={12}
                    selectFiles={selectedFiles?.length >= 1 ? [selectedFiles[0]] : []}
                    allowedFormats={"image/jpeg, image/png, application/pdf"}
                />
            ) : (
                <>
                    <Alert type="info">Un seul fichier est nécessaire si le recto/verso figure sur la même page.</Alert>
                    <FileUploader
                        onChange={handleChangeFiles}
                        onDelete={handleFileRemoval}
                        title="Recto/Verso"
                        fileLimit={1}
                        maxFileSize={12}
                        selectFiles={selectedFiles?.length >= 1 ? [selectedFiles[0]] : []}
                        allowedFormats={"image/jpeg, image/png, application/pdf"}
                    />
                    <FileUploader
                        onChange={handleChangeFiles}
                        onDelete={handleFileRemoval}
                        title="Verso"
                        fileLimit={1}
                        maxFileSize={12}
                        selectFiles={selectedFiles?.length >= 2 ? [selectedFiles[1]] : []}
                        allowedFormats={"image/jpeg, image/png, application/pdf"}
                    />
                </>
            )}
        </div>
    );
};

export default DocumentUpload;
